'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import * as CityCollectionRoute from 'marketplace-ui-solutions-core/constants/routes/CityCollectionRoute';
import * as CountryRoute from 'marketplace-ui-solutions-core/constants/routes/CountryRoute';
import * as IndustryRoute from 'marketplace-ui-solutions-core/constants/routes/IndustryRoute';
import * as StateRoute from 'marketplace-ui-solutions-core/constants/routes/USStateRoute';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import StorefrontWrapper from '../containers/StorefrontWrapper';
import ProfilesStorefront from '../containers/ProfilesStorefront';
import Profile from '../containers/Profile';
import Homepage from '../containers/Homepage';
import CityCollection from '../containers/CityCollection';
import { getServices, getServicesRequestState } from '../slices/serviceCatalogSlice';

const makeObjectValuesRouteParam = (obj, name) => {
  const objectVals = Object.values(obj);
  const routeValues = objectVals.join('|');
  return objectVals.length ? `:${name}(${routeValues})` : '';
};

const industryRouteParam = makeObjectValuesRouteParam(IndustryRoute, 'industry');
const countryRouteParam = makeObjectValuesRouteParam(CountryRoute, 'country');
const stateRouteParam = makeObjectValuesRouteParam(StateRoute, 'state');
const cityCollectionRouteParam = makeObjectValuesRouteParam(CityCollectionRoute, 'city');
const pageRouteParam = ':page([1-9][0-9]*)';
export default function Routes() {
  const services = useSelector(getServices);
  const servicesRequestState = useSelector(getServicesRequestState);
  const serviceApiNameObject = servicesRequestState === RequestStates.SUCCEEDED ? services.reduce((returnObj, service) => Object.assign({}, returnObj, {
    [service.name]: service.apiName
  }), {}) : {};
  const serviceRouteParam = makeObjectValuesRouteParam(serviceApiNameObject, 'service');
  /*
    separated out serviceRouteParamString here so that if the service catalog request fails
    we don't inadvertently generate broken routes eg routes with a floating '?'
  */

  const serviceRouteParamString = serviceRouteParam ? `/${serviceRouteParam}?` : '';
  const storefrontRoutes = ['/all', `/all/page/${pageRouteParam}`, `${serviceRouteParamString}/${industryRouteParam}?`, `${serviceRouteParamString}/${industryRouteParam}?/page/${pageRouteParam}`, `${serviceRouteParamString}/${industryRouteParam}?/${countryRouteParam}`, `${serviceRouteParamString}/${industryRouteParam}?/${countryRouteParam}/page/${pageRouteParam}`, `${serviceRouteParamString}/${industryRouteParam}?/:country(${CountryRoute.US})/${stateRouteParam}`, `${serviceRouteParamString}/${industryRouteParam}?/:country(${CountryRoute.US})/${stateRouteParam}/page/${pageRouteParam}`];
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      exact: true,
      sensitive: true,
      path: ['/', ...storefrontRoutes],
      children: /*#__PURE__*/_jsx(StorefrontWrapper, {
        children: /*#__PURE__*/_jsxs(Switch, {
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/",
            exact: true,
            component: Homepage
          }), /*#__PURE__*/_jsx(Route, {
            exact: true,
            sensitive: true,
            path: storefrontRoutes,
            component: ProfilesStorefront
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Route, {
      exact: true,
      sensitive: true,
      path: `/${cityCollectionRouteParam}`,
      component: CityCollection
    }), /*#__PURE__*/_jsx(Route, {
      path: ['/_preview', '/:profileSlug', '/:profileSlug/write-review'],
      component: Profile
    })]
  });
}